import React, { useEffect, useMemo, useState } from "react";
import SectionField from "../section/SectionField";
import styles from "./CheckBoxComponent.module.scss";
import InputTextArea from "components/shared/textArea/InputTextArea";
import FileUploadButton from "components/shared/fileUploadButton/FileUploadButton";
import { Controller, useForm } from "react-hook-form";
import TriggerButton from "components/shared/createTriggerButton/TriggerButton";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems, setUpdateDroppedItems } from "@redux/slices/formSlice";
import { capitalizeFirstLetter, handleFile, randomIntFromInterval } from "utils/utils";
import DeleteIcon from "@mui/icons-material/Delete";
import { setPublish } from "@redux/slices/globalSlice";
import { setDroppedItems as setTriggerList } from "@redux/slices/triggerSlice";
import { useNavigate, useParams } from "react-router-dom";
import { MenuItem, Select } from "@mui/material";
import toast from "react-hot-toast";
const checkboxOptions = [
  "Checked",
  "Unchecked"
]
const CheckBoxComponent = () => {
  const { publish } = useSelector((state) => state?.global);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { formId } = useParams()
  const { droppedItems, selectedData } = useSelector((state) => state.form);
  const { triggerDroppedList, trigger } = useSelector((state) => state.trigger);
  const [dependent, setDependent] = useState(false)
  const [file, setFile] = useState("");
  const [dependentOptions, setDependentOptions] = useState(checkboxOptions[0])
  const { register, handleSubmit, control, watch, setValue: setValues } = useForm({
    defaultValues: {
      showInstructions: false,
      instructions: selectedData?.instructions || "",
      whenAnswerEquals: "",
      enableDependentQuestions: selectedData?.whenAnswerEquals ? true : false,
    },
  });

  const handleChange = (field, value) => {
    const updatedData = { [field]: value };
    if (field == "enableDependentQuestions") {
      setDependent(updatedData?.enableDependentQuestions)
    } else if (field == "whenAnswerEquals") {
      setDependent(true)
    }

    // dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };
  const handleChangeSelect = (e) => {
    setDependentOptions(e?.target?.value)
    handleChange(e?.target?.name, e?.target?.value)
  }

  const handleTextChange = (e, fieldName) => {
    handleChange(fieldName, e.target.value);
  };

  // Handle file input change
  const handleFileChange = (file, setIsLoading) => {
    handleFile(file, droppedItems, selectedData, dispatch, setDroppedItems, setIsLoading);;
    dispatch(setPublish(true));
  };

  const onSubmit = (data) => {
    // console.log('Form Data:', data);
  };

  const handleClick = () => {
    // console.log('clicked....')
  };

  const handleImageDelete = (src, selectedItem) => {
    const updatedMedia = selectedItem?.data?.media.filter(
      (media) => media.path !== src
    );

    const updatedData = { media: updatedMedia };

    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };

  const handleOpenImage = (src) => {
    window.open(src, "__blank");
  };

  const currentItem = useMemo(() => {
    // Check for a match in the main fields
    let foundItem = droppedItems.find((item) => item.id === selectedData.id);

    if (!foundItem) {
      // If not found, search in dependent fields
      droppedItems.forEach((item) => {
        const dependentMatch = item.dependentField.find(
          (depField) => depField.id === selectedData.id
        );
        if (dependentMatch) {
          foundItem = dependentMatch;
        }
      });
    }

    return foundItem;
  }, [droppedItems, selectedData]);
  const handleTrigger = () => {
    const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
    dispatch(setTriggerList([
      ...triggerDroppedList, {
        ...currentItem,
        id: uniqueId
      }
    ]))
    navigate(`/create/triggers/${formId || ""}`)


  }
  // useEffect(() => {
  //   if (selectedData) {
  //     if (selectedData?.whenAnswerEquals) {
  //       setDependentOptions(capitalizeFirstLetter(selectedData?.whenAnswerEquals))
  //       handleChange("whenAnswerEquals", capitalizeFirstLetter(selectedData?.whenAnswerEquals))
  //     } else {
  //       handleChange("enableDependentQuestions", true)
  //       handleChange("whenAnswerEquals", checkboxOptions[0]);
  //     }
  //   }

  // }, [selectedData])
  const watchValues = watch();

  useEffect(() => {
    if (watch("enableDependentQuestions")) {
      if (selectedData?.whenAnswerEquals) {

        setValues("whenAnswerEquals", capitalizeFirstLetter(selectedData?.whenAnswerEquals))
      } else {
        setValues("whenAnswerEquals", checkboxOptions[0])
      }
    } else {
      setValues("whenAnswerEquals", "")
      let clearDrop = droppedItems?.map((e) => {
        return e?.id == selectedData?.id ? { ...e, dependentField: [] } : e
      })
      dispatch(setDroppedItems(clearDrop))
    }
  }, [watch("enableDependentQuestions")])
  useEffect(() => {
    if (!selectedData) return;

    const timeout = setTimeout(() => {
      dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData: watchValues }));
      // dispatch(setPublish(true));
    }, 500);

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, [watchValues, selectedData]);
  return (
    <>
      <SectionField
        placeholder="Please enter your question here."
        message="Required"
      />
      <div
        // onSubmit={handleSubmit(submitForm)}
        className={styles?.instructionsForm}
      >
        <h4>Instructions</h4>
        <div className={styles?.formField}>

          <Controller
            name="instructions"
            control={control}
            render={({ field }) => (
              <InputTextArea
                {...field}
                control={control}
                type="textarea"
                name="Optional"
                placeholder="Optional"
                onChange={(e) => {
                  field.onChange(e);
                  dispatch(setPublish(true))
                }}
                // onChange={(e) => handleTextChange(e, "instructions")}
                className={styles.textArea}
              />
            )}


          />
        </div>
        <div className={styles?.formField}>
          {currentItem?.data?.media?.length ? (
            <div className={styles.imageContainer}>
              {currentItem?.data?.media?.map((src) => {
                const fileExtension = src.path.split('.').pop().toLowerCase();

                // Function to check if file is an image
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);
                // Function to check if file is a video
                const isVideo = ['mp4', 'webm', 'ogg'].includes(fileExtension);

                return (
                  <div className={styles.imageWrapper} onClick={() => handleOpenImage(src.path)}>
                    {isImage ? (
                      <img src={src.path} alt="" />
                    ) : isVideo ? (
                      <video width="320" height="240" controls>
                        <source src={src.path} type={`video/${fileExtension}`} />
                        Your browser does not support the video tag.
                      </video>
                    ) : null}

                    <div
                      className={styles.cancelIcon}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleImageDelete(src.path, currentItem);
                      }}
                    >
                      <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <FileUploadButton
              name="mediaFile"
              control={control}
              onFileChange={handleFileChange}
            />
          )}
        </div>
      </div>

      <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label style={{ margin: "-10px 0px 10px 0px" }}>
            {/* <input
                                   
                                    type="checkbox"
                                    {...register("showInstructions")}
                                // onChange={(e) =>
                                //     handleChange("showInstructions", e.target.checked)
                                // }
                                />
                                Show instructions by default */}
            <Controller
              name={`showInstructions`}
              control={control}
              render={({ field }) => (
                <input
                  disabled={
                    !watch("instructions") && !file && !currentItem?.data?.media?.length > 0
                  }
                  type="checkbox"
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    // if (!e.target.checked) {
                    //     if (window.confirm("Un-checking this option will remove all dependent questions and any data collected from those questions. Are you sure?")) {
                    //         field.onChange(e)
                    //         dispatch(setPublish(true))
                    //     } else {
                    //         return
                    //     }
                    // }
                    field.onChange(e)
                    dispatch(setPublish(true))
                  }}
                />


              )}
            />
            Show instructions by default
          </label>
        </div>
        {/* Checkbox: Enable Dependent Questions */}
        <div>
          <label>
            <Controller
              name={`enableDependentQuestions`}
              control={control}
              render={({ field }) => (
                <input
                  type="checkbox"
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      if (window.confirm("Un-checking this option will remove all dependent questions and any data collected from those questions. Are you sure?")) {
                        field.onChange(e)
                        dispatch(setPublish(true))
                      } else {
                        return
                      }
                    }
                    field.onChange(e)
                    dispatch(setPublish(true))
                  }
                  }
                />
              )}
            />
            Enable Dependent Questions
          </label>
          {
            watch("enableDependentQuestions") && <>
              <label style={{ margin: "10px 0px" }}>Add Dependent Question When Answer Is:</label>
              <Controller
                name="whenAnswerEquals"
                control={control}
                render={({ field }) => (
                  <Select sx={{ width: "100%", height: "40px" }} name="whenAnswerEquals"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      handleChange(
                        `whenAnswerEquals`,
                        e.target.value
                      );
                    }}
                  >
                    {
                      checkboxOptions?.map((option) => {
                        return <MenuItem value={option}>{option}</MenuItem>
                      })

                    }
                  </Select>


                )}
              />

            </>

          }
        </div>

        {/* Button: Create Trigger */}
        <TriggerButton handleClick={() => {
          if (!publish) {
            handleTrigger()
          } else {
            toast.error("There are unpublished changes");
          }
        }

        } />
      </form>
    </>
  );
};

export default CheckBoxComponent;
